module.exports = __webpack_public_path__ + "static/member5-a429acd5340b2bfd7f78942d80e3a99f.png";